export default () => {
  const tabs = document.querySelectorAll('[data-show-more]');

  const init = el => {
    const wrapper = el.previousElementSibling;
    if(wrapper.offsetHeight > wrapper.dataset.oheight && window.innerWidth < 1024){
      wrapper.classList.add('show-more');
      el.addEventListener('click', () => {
        if(wrapper.classList.contains('show-more')){
          el.innerHTML = "Show Less";
        }else{
          el.innerHTML = "Show More";
        }
        wrapper.classList.toggle('show-more')
      })
    }else{
      wrapper.classList.remove('show-more')
      el.style.display = "none"
    }
  }

  tabs.forEach(el => init(el))
}